import { Routes } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { authGuard } from './core/guards/auth.guard';
import { accountGuard } from './core/guards/customer.guard';

export const routes: Routes = [
  {
    path: 'callback',
    loadComponent: () => import('./core/components/callback/callback.component').then(m => m.CallbackComponent)
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./core/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'forbidden',
    loadComponent: () => import('./core/components/forbidden/forbidden.component').then(m => m.ForbiddenComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layouts/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuard, accountGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'product-catalog',
        redirectTo: 'checkout',
        pathMatch: 'full'
      },
      {
        path: 'cart',
        redirectTo: 'checkout',
        pathMatch: 'full'
      },
      {
        path: 'checkout',
        loadComponent: () => import('./features/orders/checkout/checkout.component').then(m => m.CheckoutComponent)
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/orders/orders.routes').then(m => m.ORDERS_ROUTES)
      },
      {
        path: 'documents',
        loadComponent: () => import('./features/documents/documents.component').then(m => m.DocumentsComponent)
      },
      {
        path: 'payments',
        loadComponent: () => import('./features/payments/payments.component').then(m => m.PaymentsComponent)
      },
      {
        path: 'notifications',
        loadComponent: () => import('./features/notifications/notifications.component').then(m => m.NotificationsComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
